// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { useSelector } from 'react-redux';
import {
  MobileListItem,
  MobileListWrapper,
} from '../utils/Styles/MobileListItem';
import { getUserRoleLabel } from '../../infrastructure/utils/users';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const UsersMobileList = ({ users, onClick }) => {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  const deletedUser = useSelector(state => state.users.deletedUser);
  return (
    <MobileListWrapper>
      {users // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        .filter(us => us.id !== deletedUser)
        .map(user => (
          <MobileListItem
            style={{ display: 'block' }}
            key={user.id}
            onClick={e => onClick(e, `/users/${user.id}`)}
          >
            <div className='bold-item' style={{ float: 'right' }}>
              {getUserRoleLabel(user.role)}
            </div>
            <div>
              <h5 className='title' style={{ maxWidth: '100%' }}>
                {user.name}
              </h5>
              <div className='item' style={{ maxWidth: '100%' }}>
                {user.email}
              </div>
            </div>
          </MobileListItem>
        ))}
    </MobileListWrapper>
  );
};

export default UsersMobileList;
